<template>
  <div class="dropdown">
    <button class="dropdown-btn" @click="openMenu" @mouseleave="closeMenu">
      <span>{{ currentSort }}</span>
      <svg role="img" height="16" width="16" viewBox="0 0 16 16">
        <path fill="#666" d="M3 6l5 5.794L13 6z"></path>
      </svg>
    </button>
    <div
      class="dropdown-content"
      :class="{ open: open }"
      @mouseover="openMenu"
      @mouseleave="closeMenu"
    >
      <div
        v-for="option in sortOptions"
        :key="option"
        @click="updateSort(option)"
        class="option"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ShopDropdown",
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters({
      sortOptions: "product/getSortOptions",
      currentSort: "product/getSort",
    }),
  },
  methods: {
    openMenu() {
      this.open = true;
    },
    closeMenu() {
      this.open = false;
    },
    updateSort(option) {
      this.closeMenu();

      this.trackEvent("Feed", "Sort", option);
      this.$store.dispatch("product/updateSort", option);
      this.$store.dispatch("product/resetFeed");
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  pointer-events: all;
  .dropdown-btn {
    grid-gap: 8px;
    align-items: center;
    background-color: transparent;
    border: 0;
    border-radius: 4px;
    color: #444;
    display: grid;
    grid-template-columns: 1fr 16px;
    height: 32px;
    margin-left: 8px;
    padding: 0 8px 0 12px;
    border: #666 solid 1px;
    &:hover {
      border-color: #000;
      color: #000;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: normal;
      line-height: 16px;
      text-transform: none;
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    &.open {
      display: block;
    }
    .option {
      cursor: pointer;
      color: #444;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: normal;
      line-height: 16px;
      text-transform: none;
      &:hover {
        background-color: #f1f1f1;
        color: black;
      }
    }
  }
}
</style>
